/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import { queryOptions, useQuery } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type { FindCertificateTypesByOrganizationIdQueryResponse } from "../types/FindCertificateTypesByOrganizationId.ts"

export const findCertificateTypesByOrganizationIdQueryKey = () =>
  [{ url: "/v1/certificate-type/find-certificate-types" }] as const

export type FindCertificateTypesByOrganizationIdQueryKey = ReturnType<
  typeof findCertificateTypesByOrganizationIdQueryKey
>

/**
 * @summary Find certificate types by organization id
 * {@link /v1/certificate-type/find-certificate-types}
 */
export async function findCertificateTypesByOrganizationId(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindCertificateTypesByOrganizationIdQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/certificate-type/find-certificate-types`,
    ...requestConfig,
  })
  return res
}

export function findCertificateTypesByOrganizationIdQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findCertificateTypesByOrganizationIdQueryKey()
  return queryOptions<
    ResponseConfig<FindCertificateTypesByOrganizationIdQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindCertificateTypesByOrganizationIdQueryResponse>,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return findCertificateTypesByOrganizationId({
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find certificate types by organization id
 * {@link /v1/certificate-type/find-certificate-types}
 */
export function useFindCertificateTypesByOrganizationId<
  TData = ResponseConfig<FindCertificateTypesByOrganizationIdQueryResponse>,
  TQueryData =
    ResponseConfig<FindCertificateTypesByOrganizationIdQueryResponse>,
  TQueryKey extends QueryKey = FindCertificateTypesByOrganizationIdQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindCertificateTypesByOrganizationIdQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findCertificateTypesByOrganizationIdQueryKey()

  const query = useQuery(
    {
      ...findCertificateTypesByOrganizationIdQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
